import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Subject, Observable } from 'rxjs';

import { environment } from './../../../../environments/environment';

const USER_API_URL = `${environment.apiPrefix}/users`;
const TFA_API_URL = `${USER_API_URL}/tfa`;

@Injectable({
  providedIn: 'root',
})
export class ProfileService implements OnDestroy {
  private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  constructor(private http: HttpClient) {
    this.unsubscribe = new Subject();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  updateUser(userId: number, data: any) {
    return this.http.put(`${USER_API_URL}/${userId}`, data);
  }

  updateAvatar(userId: number, files: FileList): Observable<any> {
    const url = `${USER_API_URL}/${userId}/avatar`;
    const data = new FormData();
    data.append('avatar', files[0]);
    return this.http.post<any>(url, data);
  }

  setupTfa(user: any) {
    return this.http.post(`${TFA_API_URL}/setup`, { userId: user.id });
  }

  verifyTfa(user: any, token: string) {
    return this.http.post(`${TFA_API_URL}/verify`, { userId: user.id, token });
  }

  deleteTfa(user: any) {
    return this.http.delete(`${TFA_API_URL}/setup`, {
      params: {
        userId: user.id,
      },
    });
  }
}
